import { TParametersTrendData } from 'types/models/DataAnalysis'

export const toParametersTrendChartData = (
  arr: TParametersTrendData[],
  colorByCode: Record<string, string>
): { rows: any[]; series: { key: string; name: string; color: string }[] } => {
  if (!Array.isArray(arr)) return { rows: [], series: [] }

  // group by date
  const dateMap: Record<string, any> = {}
  let hasAnyValue = false

  arr.forEach((p) => {
    p.series_data.forEach((s) => {
      if (!dateMap[s.date]) dateMap[s.date] = { period: s.date }

      if (s.value !== null) {
        hasAnyValue = true
        dateMap[s.date][p.wheat_code] = s.value
      }
      if (s.std_dev !== null) {
        hasAnyValue = true
        dateMap[s.date][`${p.wheat_code}_std`] = s.std_dev
      }
    })
  })

  if (!hasAnyValue) {
    return { rows: [], series: [] }
  }

  const wheatCodes = arr.map((p) => p.wheat_code)
  const series = wheatCodes.map((code) => ({
    key: code,
    name: `Wheat ${code}`,
    color: colorByCode?.[code] ?? '#4f9b41',
  }))

  return { rows: Object.values(dateMap), series }
}
